import { formatMoney } from 'helpers/number';
import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['selectable', 'selectionCount', 'submitBtn', 'totalCharge', 'totalSelectionCount'];

  // One entry per selected checkbox. A service linked to more than one invoice has a checkbox (and
  // a charge) under each invoice, so entries are keyed per checkbox and counted per service.
  selectedServices = [];

  connect() {
    this.totalSelectionCountTarget.innerText = new Set(this.checkboxes.map(({ value }) => value)).size.toString();
  }

  disconnect() {
    this.selectedServices = [];
  }

  /**
   * @event Dispatched by `superbill--section:select`
   */
  selectService(event) {
    const service = this.selectedServices.find(({ key }) => key === event.detail.key);
    if (service) return;

    this.selectedServices.push(event.detail);
    this.updateUI();
  }

  /**
   * @event Dispatched by `superbill--section:deselect`
   */
  deselectService(event) {
    const index = this.selectedServices.findIndex(({ key }) => key === event.detail.key);
    if (index === -1) return;

    this.selectedServices.splice(index, 1);
    this.updateUI();
  }

  /**
   * Checking or unchecking one copy of a service applies to every copy, so the submitted ids, the
   * counter and the total always agree.
   */
  syncDuplicates({ target }) {
    // The action listens on the form, so typing in the notes field lands here too.
    if (target.type !== 'checkbox' || !this.checkboxes.includes(target)) return;

    this.checkboxes
      .filter(
        (checkbox) => checkbox !== target && checkbox.value === target.value && checkbox.checked !== target.checked
      )
      .forEach((checkbox) => {
        checkbox.checked = target.checked;
        checkbox.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
        checkbox.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
      });
  }

  // Private

  get checkboxes() {
    return this.selectableTargets
      .map((selectable) => selectable.querySelector('input[type="checkbox"]'))
      .filter(Boolean);
  }

  updateUI() {
    this.toggleBtnDisability();
    this.updateTotalCharge();
    this.selectionCountTarget.innerText = new Set(this.selectedServices.map(({ id }) => id)).size.toString();
  }

  toggleBtnDisability() {
    this.submitBtnTarget.disabled = this.selectedServices.length === 0;
  }

  updateTotalCharge() {
    this.totalChargeTarget.innerText = formatMoney(this.totalCharge);
  }

  get totalCharge() {
    return this.selectedServices.reduce((acc, service) => acc + service.charge, 0);
  }
}
